/**
 * Custom error classes for google login-related errors
 */

export class GoogleLoginConfigError extends Error {
  constructor(message: string) {
    super(message);
    this.name = "GoogleLoginConfigError";
  }
}

export class GoogleScriptLoadError extends Error {
  constructor(message: string = "Failed to load Google authentication script") {
    super(message);
    this.name = "GoogleScriptLoadError";
  }
}

export class GoogleAuthError extends Error {
  constructor(
    message: string,
    public readonly code?: string,
  ) {
    super(message);
    this.name = "GoogleAuthError";
  }
}

// Helper function to determine if an error is a specific type
export const isGoogleLoginError = (
  error: unknown,
): error is
  | GoogleLoginConfigError
  | GoogleScriptLoadError
  | GoogleAuthError => {
  return (
    error instanceof GoogleLoginConfigError
    || error instanceof GoogleScriptLoadError
    || error instanceof GoogleAuthError
  );
};
